import { controls, currencyToNumber, grouped } from "../../controls";

const rpdr22 = {
  label: "Manual Report Bank",
  starting: true,
  url: "rp101m",
  pageLabel: "Manual Report Bank",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Manual Report Bank",
    filterable: true,
    sortable: true,
    dynamicHeader:true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    extraRows: {
      location: "top",
      fields: ["dynamic_"],
      subtotals: {
        by: "report_type",
        displayIn: "observation"
      },
      // grandtotal: { type: "fixed", displayIn: "display_label", val: "Grand Total", count: true },
    },
    pivotable: true,
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Observation",
        accessor: "observation",
        rwidth: "*"
      },
      {
        Header: "Value",
        accessor: "value"
      },
    ]
  }
};

export default rpdr22;